import * as go from '../../../../../libs/gojs/release/go';
export var arrowHeaders = new Map();
arrowHeaders.set('OpenTriangle', go.Geometry.parse('m 0,0 l 8,4 -8,4'));
arrowHeaders.set('BackwardOpenTriangle', go.Geometry.parse('m 8,0 l -8,4 8,4'));
arrowHeaders.set('Triangle', go.Geometry.parse('F1 m 0,0 l 8,4 -8,4 z'));
arrowHeaders.set('BackwardTriangle', go.Geometry.parse('F1 m 8,4 l 0,4 -8,-4 8,-4 0,4 z'));
var ArrowHeaders = /** @class */ (function () {
    function ArrowHeaders() {
    }
    ArrowHeaders.get = function (name) {
        return arrowHeaders.get(name);
    };
    return ArrowHeaders;
}());
export { ArrowHeaders };
